import { ThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider, THEME_ID } from "@mui/material/styles";
import "@fontsource-variable/fredoka";
import "@fontsource-variable/nunito";
import { ToastContainer } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { defaultTheme } from "./style/theme";
import { materialTheme } from "./style/materialTheme";
import { GlobalStyles } from "./style/GlobalStyles";
import Router from "./routes";

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <MuiThemeProvider theme={{ [THEME_ID]: materialTheme }}>
        <GlobalStyles />
        <ToastContainer autoClose={2000} hideProgressBar={false} closeButton={false} />
        <Router />
      </MuiThemeProvider>
    </ThemeProvider>
  );
}

export default App;
